import React, { useCallback } from 'react';
import Card from 'components/Card';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';
import { DataForm, Input } from 'components/formik_inputs';
import { PermissionContext } from 'hoc/withPermission';
import { useHistory, useLocation, useParams } from 'react-router';
import Button from 'components/common/buttons/Button';
import { useReport } from 'reports/hooks';
import TextArea from 'components/formik_inputs/TextArea';
import ReportService from 'reports/services';
import { toast } from 'react-toastify';
import { nativeGet as get } from 'utils';

const ReportFormPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const history = useHistory();
  const edit = location.pathname.includes('edit');

  const { data: report } = useReport(+id);

  const saveReport = useCallback(
    async (values: { name: string; sql: string }) => {
      if (edit) {
        await ReportService.update(+id, values);

        toast.success('Relatório editado com sucesso.');
      } else {
        const { id: newId } = await ReportService.create(values);

        toast.success('Relatório criado com sucesso.');
        history.push(`/relatorios/${newId}/edit`);
      }
    },
    [id]
  );

  const handleDelete = useCallback(async () => {
    try {
      await ReportService.delete(+id);

      toast.success('Relatório excluído com sucesso.');
      history.push('/relatorios');
    } catch (err) {
      const error = get(err, 'response.data.detail');
      toast.error(error || 'Ocorreu um erro ao remover a Relatório.');
    }
  }, [id]);

  return (
    <Card title={`${edit ? 'Editar' : 'Cadastrar'} relatório`}>
      <DataForm
        initialValues={edit ? report : { sql: '', name: '' }}
        onSubmit={saveReport}
        autoSetErrors
        enableReinitialize
        submitOnChange={undefined}
      >
        <>
          <Input name="name" label="Nome" required />
          <TextArea name="sql" label="SQL" required />
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '20px',
            }}
          >
            <Button onClick={() => history.push('/relatorios')}>Voltar</Button>
            <div>
              <PermissionContext.Consumer>
                {({ hasPermission }) =>
                  hasPermission('reports.delete_sqlreport') &&
                  edit && (
                    <ButtonWithConfirmation
                      action="danger"
                      confirmationText="Deseja excluir permanentemente esse Relatório ?"
                      onClick={handleDelete}
                    >
                      Excluir
                    </ButtonWithConfirmation>
                  )
                }
              </PermissionContext.Consumer>
              <Button type="submit">Salvar</Button>
            </div>
          </div>
        </>
      </DataForm>
    </Card>
  );
};

export default ReportFormPage;
